import { isKarangoApiEnabled, requestKarangoApi } from "../../../core/api/karangoTransport";

const LIST_PROFILES_PAGE_SIZE = 50;

export async function listRemoteProfilesPage({
  limit = LIST_PROFILES_PAGE_SIZE,
  cursor,
  signal,
} = {}) {
  const params = new URLSearchParams();
  params.set("limit", String(limit));

  if (cursor) {
    params.set("cursor", String(cursor));
  }

  const payload = await requestKarangoApi(
    `/v1/profiles?${params.toString()}`,
    { signal, requiresAuth: true }
  );

  return {
    profiles: Array.isArray(payload?.profiles) ? payload.profiles : [],
    nextCursor: payload?.nextCursor || null,
  };
}

export async function listRemoteProfiles({ limit = 200, signal } = {}) {
  const targetLimit = Math.max(0, Number.parseInt(String(limit || 0), 10) || 0);
  const profiles = [];
  let cursor = null;

  if (targetLimit === 0) {
    return profiles;
  }

  do {
    const remaining = targetLimit - profiles.length;
    const page = await listRemoteProfilesPage({
      limit: Math.min(LIST_PROFILES_PAGE_SIZE, remaining),
      cursor,
      signal,
    });

    profiles.push(...page.profiles);
    cursor = page.nextCursor;
  } while (cursor && profiles.length < targetLimit);

  return profiles;
}

export async function getRemoteProfile(userId, { signal } = {}) {
  if (!userId) {
    return null;
  }

  const payload = await requestKarangoApi(
    `/v1/profiles/${encodeURIComponent(String(userId))}`,
    { signal, requiresAuth: true }
  );

  return payload?.profile || null;
}

export async function reportRemoteProfile(
  userId,
  { reason = "other", details = "Signalement depuis le profil utilisateur.", signal } = {}
) {
  if (!userId) {
    return null;
  }

  const payload = await requestKarangoApi("/v1/reports", {
    method: "POST",
    requiresAuth: true,
    signal,
    body: {
      targetType: "USER_PROFILE",
      targetId: String(userId),
      reason,
      details,
    },
  });

  return payload?.report || null;
}

export async function getRemoteCurrentUser({ signal } = {}) {
  const payload = await requestKarangoApi("/v1/me", {
    requiresAuth: true,
    signal,
  });

  return payload?.user || null;
}

// firebaseUser / sessionGuard : identite figee au depart (voir core/auth/authSession).
export async function updateRemoteCurrentUser(profilePatch = {}, { firebaseUser = null, sessionGuard = null } = {}) {
  const payload = await requestKarangoApi("/v1/me", {
    method: "PATCH",
    requiresAuth: true,
    body: profilePatch,
    firebaseUser,
    sessionGuard,
  });

  return payload?.user || null;
}

export async function bootstrapRemoteSession(firebaseUser) {
  if (!firebaseUser || !isKarangoApiEnabled()) {
    return null;
  }

  const payload = await requestKarangoApi("/v1/session/bootstrap", {
    method: "POST",
    requiresAuth: true,
    firebaseUser,
  });

  return {
    user: payload?.user || null,
    claimsUpdated: Boolean(payload?.claimsUpdated),
  };
}
